import { Link } from "react-router-dom";

// A5 (auditoría V2): política de privacidad real enlazada desde el login.
// BORRADOR honesto pendiente de revisión de Jorge — huecos marcados
// [PENDIENTE JORGE: …]; no inventar datos legales ahí.

function Placeholder({ children }) {
  return (
    <span className="bg-amber-100 text-amber-900 px-1 rounded text-sm font-medium">
      [PENDIENTE JORGE: {children}]
    </span>
  );
}

export default function LegalPrivacy() {
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white border border-slate-200 rounded-lg p-8 space-y-6">
        <div className="bg-amber-50 border border-amber-200 text-amber-800 rounded-md px-4 py-3 text-sm">
          <strong>Borrador pendiente de revisión legal.</strong> Versión de
          trabajo para la beta privada; se revisará antes de cualquier apertura
          comercial.
        </div>

        <div>
          <h1 className="font-heading text-2xl font-bold text-slate-900">
            Política de privacidad
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Última actualización: julio de 2026 (borrador)
          </p>
        </div>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">1. Responsable del tratamiento</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            <Placeholder>titular legal — nombre o razón social, NIF y
            domicilio</Placeholder>. Contacto para cualquier cuestión de
            privacidad y ejercicio de derechos:{" "}
            <a href="mailto:info@nexobound.com" className="text-blue-600 underline">
              info@nexobound.com
            </a>.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">2. Qué datos tratamos</h2>
          <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
            <li>
              <strong>Datos de tu cuenta:</strong> email, nombre y contraseña
              (almacenada con hash seguro).
            </li>
            <li>
              <strong>Datos de tu negocio que tú introduces:</strong> facturas
              emitidas y recibidas, clientes y proveedores, movimientos
              bancarios que importes, presupuestos y ajustes de tu perfil
              fiscal.
            </li>
            <li>
              <strong>Datos técnicos mínimos:</strong> cookies de sesión
              (imprescindibles para el acceso; no usamos cookies de publicidad
              ni de seguimiento).
            </li>
          </ul>
          <p className="text-sm text-slate-700 leading-relaxed">
            Los datos de tus clientes y proveedores que introduces en la
            aplicación los tratas tú como responsable; LiquidArc actúa como
            encargado del tratamiento por tu cuenta.{" "}
            <Placeholder>contrato de encargo del tratamiento (art. 28
            RGPD) para la beta</Placeholder>
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">3. Para qué los usamos</h2>
          <ul className="list-disc pl-5 text-sm text-slate-700 space-y-1">
            <li>Prestarte el servicio: registrar, calcular y mostrarte tu información.</li>
            <li>Enviarte los avisos que tú configures (por ejemplo, vencimientos de facturas).</li>
            <li>Atender soporte y comunicaciones de la beta.</li>
          </ul>
          <p className="text-sm text-slate-700 leading-relaxed">
            No vendemos tus datos ni los cedemos a terceros con fines
            comerciales.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">
            4. Funciones con IA (opcionales, con tu consentimiento)
          </h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            La lectura automática de facturas (OCR) y el análisis financiero
            con IA usan la API de Google Gemini. Estas funciones están{" "}
            <strong>desactivadas por defecto</strong> y solo se activan con tu
            consentimiento explícito en Ajustes → IA. Si las activas, el texto
            de los documentos que subas al OCR — y, cuando subes una foto, una
            imagen o un PDF escaneado sin capa de texto, la imagen del propio
            documento — y resúmenes de tus cifras se envían a Google como
            subencargado para generar el resultado.
            Puedes retirar el consentimiento en cualquier momento en el mismo
            sitio. <Placeholder>DPA con Google y condiciones del
            subencargo</Placeholder>
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">5. Dónde se alojan tus datos</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            <Placeholder>hosting §9 — proveedor, ubicación de servidores,
            cifrado y política de copias de seguridad</Placeholder>
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">6. Cuánto tiempo los conservamos</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            Mientras mantengas tu cuenta. Si la cierras, eliminamos tus datos
            salvo lo que debamos conservar por obligación legal. Puedes pedir
            la eliminación completa en{" "}
            <a href="mailto:info@nexobound.com" className="text-blue-600 underline">
              info@nexobound.com
            </a>.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-heading text-lg font-semibold text-slate-900">7. Tus derechos</h2>
          <p className="text-sm text-slate-700 leading-relaxed">
            Puedes ejercer tus derechos de acceso, rectificación, supresión,
            oposición, limitación y portabilidad escribiendo a{" "}
            <a href="mailto:info@nexobound.com" className="text-blue-600 underline">
              info@nexobound.com
            </a>. Si consideras que no hemos atendido bien una solicitud,
            puedes reclamar ante la Agencia Española de Protección de Datos
            (aepd.es).
          </p>
        </section>

        <div className="pt-4 border-t border-slate-200 flex items-center justify-between">
          <Link to="/login" className="text-sm text-blue-600 underline">
            ← Volver al acceso
          </Link>
          <Link to="/terminos" className="text-sm text-blue-600 underline">
            Términos de servicio →
          </Link>
        </div>
      </div>
    </div>
  );
}
